module.exports = __webpack_public_path__ + "./assets/img/quote.c2dd2d61.svg";